<template>
      <v-carousel>
    <v-carousel-item
      v-for="(image,i) in images"
      :key="i"      
      reverse-transition="fade-transition"
      transition="fade-transition"
      content-class="Image-Container-Style"
    >
    <div class="Container-CenterIMG">
      <img class="image-contain" :src="image.src" :style="`transform: rotate(${rotation}deg); padding: 10px; cursor: pointer;`" />
    </div>   

    <div style="width:100%; height:100%;">
      <v-btn icon class="btn-rotateIMG" @click="rotateRight()"><i class="fas fa-sync"></i></v-btn>
    </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data () {
    return {
      rotation: 0,
    }
  },
  props: {
    images: {
      type: Array,
      default: []
    }
  },
  mounted () {
    
  },
  methods: {
    rotateRight() {
     this.rotation += 90
    },
    closeClick () {
      
    },
  }
}
</script>